module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.item.first_name + ' ' + _vm.item.last_name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(administrator)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.users.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do administratorów")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj administratora")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                Imię i nazwisko\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.item.first_name + ' ' + _vm.item.last_name) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                E-mail\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.item.email) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f729f20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Show.vue
// module id = 270
// module chunks = 0